import React from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* About Us Card */}
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
            <h2 className="text-3xl font-bold text-catalina-blue mb-4">
              About Us
            </h2>
            <p className="text-gray-600 mb-4 italic">
              Learn more about our company
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Trolift is built on the values of quality, reliability, and
              customer-first service, offering a range of Telescopic Ladders,
              Platform Trolleys, and Pallet Trucks designed for both commercial
              and residential needs. The company is led by Rakesh Sharma, whose
              industry experience drives operational excellence, and backed by
              Pratik Kathuria as a consultant, bringing strategic expertise in
              sales, supply chain, and business growth.
            </p>
            <Link
              to="/about"
              className="bg-catalina-blue text-white px-6 py-3 rounded-lg font-semibold hover:bg-catalina-blue/90 transition duration-300 inline-block"
            >
              Learn More About Us
            </Link>
          </div>

          {/* Our Expertise Card */}
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
            <div className="flex justify-center mb-4 overflow-hidden rounded-lg">
              <img
                src="/about-us-expertise-img.jpg"
                alt="Our Expertise - Professional Team"
                className="w-full h-64 object-cover"
              />
            </div>
            <h3 className="text-2xl font-bold text-catalina-blue mb-3 text-center">
              Our Expertise
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Years of experience in delivering quality solutions
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
